module.exports = __webpack_public_path__ + "img/teak_brown_ba_detail_rsh.fd24015b.jpg";